<template>
  <b-modal 
    v-model="visible" 
    size="lg" 
    centered 
    title="Analizy przestrzenne" 
    @hidden="clear" 
    @shown="onShown">

    <div v-if="activeLayerSelected">
      <b-row>
        <b-col>
          <b-alert :show="hasErrors" variant="danger">
            <strong>Uwaga.</strong> Formularz zawiera błędy.
          </b-alert>
        </b-col>
      </b-row>

      <b-row v-if="submitted && selectedAnalysisTypeIsEmpty">
        <b-col offset="3" cols="9">
          <small class="text-danger">
              Należy wybrać rodzaj analizy.
          </small>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">
          <label for="analysisTypeSelect">Wybierz rodzaj analizy</label>
        </b-col>
        <b-col cols="9">
          <b-form-select id="analysisTypeSelect" v-model="selectedAnalysisType" :options="spatialAnalysisTypes">
            <template slot="first">
              <option :value="null">Wybierz</option>
            </template>
          </b-form-select>
        </b-col>
      </b-row>

      <geometry ref="anaylysisComponent" v-if="selectedAnalysisType === 'geometry'" :reference-layers="userAndTemporaryLayers" :hasErrors.sync="analysisHasErrors" :waitingForResponse.sync="waitingForResponse"></geometry>
      <buffer ref="anaylysisComponent" v-else-if="selectedAnalysisType === 'buffer'" :hasErrors.sync="analysisHasErrors" :waitingForResponse.sync="waitingForResponse"></buffer>
      <points ref="anaylysisComponent" v-else-if="selectedAnalysisType === 'points'" :reference-layers="userAndTemporaryLayers" :hasErrors.sync="analysisHasErrors" :waitingForResponse.sync="waitingForResponse"></points>
      <proximity ref="anaylysisComponent" v-else-if="selectedAnalysisType === 'proximity'" :source-layers="userAndTemporaryLayers" :hasErrors.sync="analysisHasErrors" :waitingForResponse.sync="waitingForResponse"></proximity>
      <number-of-nearest ref="anaylysisComponent" v-else-if="selectedAnalysisType === 'numberOfNearest'" :source-layers="userAndTemporaryLayers" :hasErrors.sync="analysisHasErrors" :waitingForResponse.sync="waitingForResponse"></number-of-nearest>
    </div>
    <b-alert v-else variant="info" show class="mb-0"><strong>Informacja.</strong> Należy wybrać warstwę aktywną.</b-alert>
    <div slot="modal-footer">
      <b-btn variant="primary" v-show="activeLayerSelected" :disabled="waitingForResponse" @click="submit">Zastosuj</b-btn>
      <b-btn variant="outline-secondary" @click="clear">Anuluj</b-btn>
    </div>
    <loading-overlay :active="waitingForResponse" :is-full-page="false"></loading-overlay>
  </b-modal>
</template>

<script>
import { SPATIAL_ANALYSIS_HIDE_MODAL } from '../../store/mutations.type';
import Geometry from './Geometry';
import Buffer from './Buffer';
import Points from './Points';
import Proximity from './Proximity';
import NumberOfNearest from './NumberOfNearest';
import LoadingOverlay from 'vue-loading-overlay';

export default {
  components: {
    Geometry,
    Buffer,
    Points,
    Proximity,
    NumberOfNearest,
    LoadingOverlay
  },
  data() {
    return {
      spatialAnalysisTypes: [
        { text: 'Analiza geometrii', value: 'geometry' },
        { text: 'Buforowanie', value: 'buffer' },
        { text: 'Zlicz liczbę punktów', value: 'points' },
        { text: 'Analiza sąsiedztwa', value: 'proximity' },
        { text: 'Najbliższy obiekt(y)', value: 'numberOfNearest' }
      ],
      selectedAnalysisType: null,
      userAndTemporaryLayers: null,
      submitted: false,
      analysisHasErrors: false,
      waitingForResponse: false
    }
  },
  watch: {
    selectedAnalysisType() {
      this.submitted = false;
    }
  },
  computed: {
    visible: {
      get() { return this.$store.getters.spatialAnalysisModalVisible; },
      set(value) { if (!value) this.$store.commit(SPATIAL_ANALYSIS_HIDE_MODAL); }
    },
    activeLayerSelected() {
      return !!this.$store.getters.layers.find(l => l.active);
    },
    selectedAnalysisTypeIsEmpty() {
      return !this.selectedAnalysisType;
    },
    hasErrors() {
      return this.submitted && (this.analysisHasErrors || this.selectedAnalysisTypeIsEmpty);
    }
  },
  methods: {
    onShown() {
      this.userAndTemporaryLayers = 
        this.$store.getters.layers
        .filter(f => !f.isSystem && ['point', 'linestring', 'polygon'].includes(f.type))
        .map(f => ({ text: f.title, value: { type: 'warstwa_id', id: f.id }}))
        .concat(this.$store.getters.temporaryLayers.map(tl => ({ text: tl.title, value: { type: 'features_geojson', geojson: tl.getGeojson() }})));
    },
    async submit(e) {
      if (this.activeLayerSelected) {
        e.preventDefault();

        this.submitted = true;
        await this.$refs.anaylysisComponent.submit();
      }
    },
    clear() {
      this.selectedAnalysisType = null;
      this.waitingForResponse = false;
      this.visible = false;
    }
  }
}
</script>
